<div class="modal-header align-items-start pb-2">
    <div>
        <h2 class="modal-title fs-5">
            @if (savedExport === null) {
                {{ 'savedexport_deliverylog_title_all' | translate: 'online' : 'export' }}
            } @else {
                {{ 'savedexport_deliverylog_title' | translate: 'online' : 'export' }}
            }
        </h2>
        @if (savedExport !== null) {
            <div class="text-secondary small">{{ savedExport.name }}</div>
        }
    </div>
    <button
        type="button"
        class="btn-close"
        [attr.aria-label]="'savedexport_export_modal_close' | translate: 'online' : 'export'"
        (click)="activeModal.dismiss()"></button>
</div>

<div class="modal-body">
    @if (hasFailed()) {
        <div class="alert alert-warning">
            {{ 'savedexport_deliverylog_unavailable' | translate: 'online' : 'export' }}
        </div>
    } @else {
        <div class="d-flex justify-content-end mb-2">
            <button
                type="button"
                class="btn btn-outline-primary d-inline-flex align-items-center gap-2 text-nowrap"
                (click)="resetFilters()">
                <i class="bi bi-arrow-counterclockwise" aria-hidden="true"></i>
                {{ 'savedexport_overview_filter_reset' | translate: 'online' : 'export' }}
            </button>
        </div>

        <app-export-table
            [columns]="columns"
            [currentSorting]="sorting()"
            [loading]="isLoading()"
            (sort)="onSort($event)">
            <tr appExportTableFilters [formGroup]="filters">
                <td class="align-top">
                    <app-input-dropdown-checkboxes
                        formControlName="statuses"
                        [placeholder]="
                            'savedexport_deliverylog_filter_status_all'
                                | translate: 'online' : 'export'
                        " />
                </td>
                <td class="align-top">
                    <app-input-date-group
                        class="d-block delivery-log-date"
                        formControlName="deliveredOn" />
                </td>
                <td class="align-top">
                    <input
                        type="search"
                        class="form-control delivery-log-search"
                        formControlName="exportName"
                        [placeholder]="
                            'savedexport_deliverylog_search_placeholder'
                                | translate: 'online' : 'export'
                        " />
                </td>
                <td class="align-top">
                    <input
                        type="search"
                        class="form-control delivery-log-search"
                        formControlName="destination"
                        [placeholder]="
                            'savedexport_deliverylog_search_destination_placeholder'
                                | translate: 'online' : 'export'
                        " />
                </td>
                <td class="align-top">
                    <app-input-dropdown-checkboxes
                        formControlName="reasons"
                        [placeholder]="
                            'savedexport_deliverylog_filter_reason_all'
                                | translate: 'online' : 'export'
                        " />
                </td>
                <td class="align-top"></td>
            </tr>
            @for (row of rows(); track row.key) {
                @let delivery = row.delivery;
                @let isExpanded = row.key === expandedKey();
                <tr
                    [class.delivery-log-expanded]="isExpanded"
                    [class.border]="isExpanded"
                    [class.border-primary]="isExpanded"
                    [class.border-bottom-0]="isExpanded"
                    class="text-nowrap"
                    style="cursor: pointer"
                    [attr.aria-expanded]="isExpanded"
                    (click)="toggleDetails(row.key)">
                    <td class="align-middle">
                        <app-delivery-outcome-icon [outcome]="delivery.outcome" />
                    </td>
                    <td class="align-middle">{{ delivery.deliveredAt | appdatetime }}</td>
                    <td class="align-middle fw-bold">
                        <div
                            class="text-truncate delivery-log-truncate"
                            [title]="delivery.exportName ?? ''">
                            {{ delivery.exportName ?? '-' }}
                        </div>
                    </td>
                    <td class="align-middle">
                        <div
                            class="text-truncate delivery-log-truncate"
                            [title]="delivery.destination ?? ''">
                            {{ delivery.destination ?? '-' }}
                        </div>
                    </td>
                    <td class="align-middle delivery-log-reason">
                        <div class="text-truncate">
                            @if (delivery.failureReason !== null) {
                                {{
                                    failureReasonShortLabelKeys[delivery.failureReason]
                                        | translate: 'online' : 'export'
                                }}
                            } @else if (delivery.notifiedAddresses !== '') {
                                <span class="text-secondary">
                                    <i class="bi bi-envelope me-1" aria-hidden="true"></i>
                                    {{
                                        'savedexport_deliverylog_delivered_on_attempt'
                                            | translate
                                                : 'online'
                                                : 'export'
                                                : [delivery.attempts.toString()]
                                    }}
                                </span>
                            } @else {
                                -
                            }
                        </div>
                    </td>
                    <td class="align-middle text-end">
                        <i
                            class="bi text-primary"
                            [class.bi-chevron-down]="!isExpanded"
                            [class.bi-chevron-up]="isExpanded"
                            aria-hidden="true"></i>
                    </td>
                </tr>
                @if (isExpanded) {
                    <tr hidden></tr>
                    <tr class="delivery-log-expanded border border-top-0 border-primary">
                        <td [attr.colspan]="columns.length">
                            <div class="card">
                                <div class="card-header">
                                    {{
                                        'savedexport_deliverylog_details_title'
                                            | translate: 'online' : 'export'
                                    }}
                                </div>
                                <div class="card-body py-1">
                                    <ul class="list-group list-group-flush">
                                        <li class="list-group-item px-0">
                                            <div class="row">
                                                <span class="col-sm-3 fw-bold">
                                                    {{
                                                        'savedexport_deliverylog_column_status'
                                                            | translate: 'online' : 'export'
                                                    }}
                                                </span>
                                                <span class="col-sm-9">
                                                    {{
                                                        outcomeLabelKeys[delivery.outcome]
                                                            | translate: 'online' : 'export'
                                                    }}
                                                </span>
                                            </div>
                                        </li>
                                        <li class="list-group-item px-0">
                                            <div class="row">
                                                <span class="col-sm-3 fw-bold">
                                                    {{
                                                        'savedexport_deliverylog_column_destination'
                                                            | translate: 'online' : 'export'
                                                    }}
                                                </span>
                                                <span class="col-sm-9 text-wrap">
                                                    {{ delivery.destination ?? '-' }}
                                                </span>
                                            </div>
                                        </li>
                                        @if (delivery.outcome === 'DELIVERED') {
                                            <li class="list-group-item px-0">
                                                <div class="row">
                                                    <span class="col-sm-3 fw-bold">
                                                        {{
                                                            'savedexport_deliverylog_column_file'
                                                                | translate: 'online' : 'export'
                                                        }}
                                                    </span>
                                                    <span class="col-sm-9 text-wrap text-break">
                                                        {{ delivery.fileName ?? '-' }}
                                                    </span>
                                                </div>
                                            </li>
                                            <li class="list-group-item px-0">
                                                <div class="row">
                                                    <span class="col-sm-3 fw-bold">
                                                        {{
                                                            'savedexport_deliverylog_column_size'
                                                                | translate: 'online' : 'export'
                                                        }}
                                                    </span>
                                                    <span class="col-sm-9">
                                                        {{
                                                            delivery.bytes !== null
                                                                ? (delivery.bytes | appformatbytes)
                                                                : '-'
                                                        }}
                                                    </span>
                                                </div>
                                            </li>
                                            <li class="list-group-item px-0">
                                                <div class="row">
                                                    <span class="col-sm-3 fw-bold">
                                                        {{
                                                            'savedexport_deliverylog_column_duration'
                                                                | translate: 'online' : 'export'
                                                        }}
                                                    </span>
                                                    <span class="col-sm-9">
                                                        @if (delivery.durationSeconds !== null) {
                                                            {{
                                                                delivery.durationSeconds
                                                                    | appnumber: 1
                                                            }}
                                                            s
                                                        } @else {
                                                            -
                                                        }
                                                    </span>
                                                </div>
                                            </li>
                                            @if (delivery.attempts > 1) {
                                                <li class="list-group-item px-0">
                                                    <div class="row">
                                                        <span class="col-sm-3 fw-bold">
                                                            {{
                                                                'savedexport_deliverylog_details_attempts'
                                                                    | translate: 'online' : 'export'
                                                            }}
                                                        </span>
                                                        <span class="col-sm-9 text-wrap">
                                                            {{
                                                                row.attemptsSummaryKey
                                                                    | translate
                                                                        : 'online'
                                                                        : 'export'
                                                                        : row.attemptsSummaryParams
                                                            }}
                                                        </span>
                                                    </div>
                                                </li>
                                            }
                                            @if (delivery.notifiedAddresses !== '') {
                                                <li class="list-group-item px-0">
                                                    <div class="row">
                                                        <span class="col-sm-3 fw-bold">
                                                            {{
                                                                'savedexport_deliverylog_details_failure_email'
                                                                    | translate: 'online' : 'export'
                                                            }}
                                                        </span>
                                                        <span class="col-sm-9 text-wrap">
                                                            {{
                                                                'savedexport_deliverylog_details_failure_email_sent_earlier'
                                                                    | translate
                                                                        : 'online'
                                                                        : 'export'
                                                                        : [
                                                                              delivery.notifiedAddresses,
                                                                          ]
                                                            }}
                                                        </span>
                                                    </div>
                                                </li>
                                            }
                                        }
                                        @if (delivery.failureReason !== null) {
                                            <li class="list-group-item px-0">
                                                <div class="row">
                                                    <span class="col-sm-3 fw-bold">
                                                        {{
                                                            'savedexport_deliverylog_column_reason'
                                                                | translate: 'online' : 'export'
                                                        }}
                                                    </span>
                                                    <span class="col-sm-9 text-danger text-wrap">
                                                        {{
                                                            failureReasonLabelKeys[
                                                                delivery.failureReason
                                                            ] | translate: 'online' : 'export'
                                                        }}
                                                    </span>
                                                </div>
                                            </li>
                                            @if (delivery.notifiedAddresses !== '') {
                                                <li class="list-group-item px-0">
                                                    <div class="row">
                                                        <span class="col-sm-3 fw-bold">
                                                            {{
                                                                'savedexport_deliverylog_details_failure_email'
                                                                    | translate: 'online' : 'export'
                                                            }}
                                                        </span>
                                                        <span class="col-sm-9 text-wrap">
                                                            {{
                                                                'savedexport_deliverylog_details_failure_email_sent'
                                                                    | translate
                                                                        : 'online'
                                                                        : 'export'
                                                                        : [
                                                                              delivery.notifiedAddresses,
                                                                          ]
                                                            }}
                                                        </span>
                                                    </div>
                                                </li>
                                            }
                                            @if (row.nextAttemptLabelKey !== null) {
                                                <li class="list-group-item px-0">
                                                    <div class="row">
                                                        <span class="col-sm-3 fw-bold">
                                                            {{
                                                                'savedexport_deliverylog_details_next_attempt'
                                                                    | translate: 'online' : 'export'
                                                            }}
                                                        </span>
                                                        <span class="col-sm-9">
                                                            {{
                                                                row.nextAttemptLabelKey
                                                                    | translate: 'online' : 'export'
                                                            }}
                                                        </span>
                                                    </div>
                                                </li>
                                            }
                                        }
                                    </ul>
                                </div>
                            </div>
                        </td>
                    </tr>
                }
            } @empty {
                <tr>
                    <td [attr.colspan]="columns.length">
                        @if (loadedCount() === 0) {
                            {{ 'savedexport_deliverylog_empty' | translate: 'online' : 'export' }}
                        } @else {
                            {{
                                'savedexport_deliverylog_no_matches'
                                    | translate: 'online' : 'export'
                            }}
                        }
                    </td>
                </tr>
            }
        </app-export-table>

        @if (totalCount() > loadedCount()) {
            <p class="text-secondary small mt-3 mb-0">
                {{ 'savedexport_deliverylog_truncated' | translate: 'online' : 'export' }}
            </p>
        }
    }
</div>
